module.exports = __webpack_public_path__ + "img/engagementbox@2x.9e7f938.jpg";